import { PropertyHealthAudit } from '../../types/inventoryHealth';

export function exportHealthAuditsToCsv(audits: PropertyHealthAudit[]): void {
  const headers = [
    'Código',
    'Código BRP',
    'Tipo Inmueble',
    'Dueño / Propietario',
    'Ciudad',
    'Dirección',
    'Precio Venta',
    'Valor Administración',
    'Piso',
    'Ascensor',
    'Antigüedad',
    'Latitud',
    'Longitud',
    'Estrato',
    'Área',
    'Puntaje Salud',
    'Estado Salud',
    'Cantidad Incidencias',
    'Detalle Incidencias',
  ];

  const rows = audits.map((a) => {
    const p = a.property;
    const issuesText = a.issues.map((i) => `[${i.severity.toUpperCase()}] ${i.ruleName}: ${i.message}`).join(' | ');
    const healthStatus = a.isHealthy ? 'Sano' : a.hasCritical ? 'Crítico' : 'Advertencia';

    return [
      `"${p.codigo || ''}"`,
      `"${p.codigo_brp || ''}"`,
      `"${p.tipoinmueble || ''}"`,
      `"${p.owner || 'No asignado'}"`,
      `"${p.ciudad || ''}"`,
      `"${(p.direccion || '').replace(/"/g, '""')}"`,
      p.precio_venta || 0,
      p.valor_administracion || 0,
      `"${p.piso ?? ''}"`,
      `"${p.ascensor !== undefined && p.ascensor !== null ? (p.ascensor ? 'Sí' : 'No') : 'No asignado'}"`,
      `"${p.antiguedad !== undefined && p.antiguedad !== null ? p.antiguedad : ''}"`,
      p.latitude ?? '',
      p.longitude ?? '',
      p.estrato ?? '',
      `"${p.area_construida || p.area_construida_original || ''}"`,
      a.score,
      healthStatus,
      a.issues.length,
      `"${issuesText.replace(/"/g, '""')}"`,
    ].join(',');
  });

  const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\r\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `auditoria_salud_inventario_183150_${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
